export default __webpack_public_path__ + "static/media/github_ico.3f99d103.svg";